import { EnumFeature, EnumScreenName } from '@calm/evexia-analytics';
import { createContext } from 'react';

export interface AnalyticsStateOverrideProps {
    currentScreenName?: EnumScreenName;
    currentFeature?: EnumFeature;
}

export const AnalyticsStateOverrideContext = createContext<{
    stateOverride: AnalyticsStateOverrideProps;
}>({ stateOverride: {} });
